import { render, staticRenderFns } from "./viewTraslado.vue?vue&type=template&id=0d49eb21"
import script from "./viewTraslado.vue?vue&type=script&lang=js"
export * from "./viewTraslado.vue?vue&type=script&lang=js"
import style0 from "./viewTraslado.vue?vue&type=style&index=0&id=0d49eb21&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports